import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

export interface Iprops {
  open: boolean;
  handleClose: () => void;
  action: () => void;
  id: string;
}
export default class DeleteDialog extends React.Component<Iprops> {
  render() {
    const { open, handleClose, action, id } = this.props
    return(
      <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Delete Charity"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure that you want to delete this charity?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} style={{color: 'red'}}>
              No
            </Button>
            <Button onClick={() => {action(); handleClose()}} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
    )
  }
}